import { ComponentProps, FC, ReactElement } from "react";
import styles from "./styles.module.scss";
import { useThrottle } from "@/common/hooks/useThrottle";
import { Spinner } from "@/shared/ui/Spinner";
import { twCn } from "@/styles/utils";

interface Props extends ComponentProps<"button"> {
  id: string;
  text: ReactElement | string;
  type?: "button" | "submit";
  outlined?: boolean;
  alert?: boolean;
  positive?: boolean;
  flexStart?: boolean;
  flexCenter?: boolean;
  loading?: boolean;
  insuranceBrand?: boolean;
}

export const MainButton: FC<Props> = ({
  id,
  text,
  onClick,
  type = "button",
  outlined = false,
  alert = false,
  positive = false,
  className,
  style,
  flexStart = false,
  flexCenter = false,
  loading = false,
  disabled = false,
  insuranceBrand = false,
}) => {
  const throttledClick = useThrottle(onClick);
  return (
    <button
      id={`${id}-button`}
      type={type}
      style={style}
      className={twCn(
        styles.mainButton,
        { [styles.outlined]: outlined },
        { [styles.alert]: alert },
        { [styles.positive]: positive },
        { [styles.flexStart]: flexStart },
        { [styles.flexCenter]: flexCenter },
        insuranceBrand && styles.insuranceBrand,
        className,
      )}
      onClick={throttledClick}
      disabled={disabled || loading}
    >
      <div className={styles.textWrapper}>
        <span className={twCn(loading && "opacity-0")}>{text}</span>
        {loading && (
          <div className={styles.spinnerWrapper}>
            <Spinner isButton />
          </div>
        )}
      </div>
    </button>
  );
};
